import { render } from "./index.vue?vue&type=template&id=5eafe896"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/user-invitation-list/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5eafe896"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5eafe896', __exports__)) {
    api.reload('5eafe896', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5eafe896", () => {
    api.rerender('5eafe896', render)
  })

}


export default __exports__